module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/12mill-active-578033ac4c6f3c1f26681b2f9e1d3b53.png";